import React from "react";
import { AgentMapSearch as MapsSearch, IMapAgent } from "@organic-return/foundation-react/src/components/Blades/AgentMapSearch"
import { useStaticQuery, graphql, Link } from "gatsby";
import { useSiteContext } from "../common/SiteContext";

const PartnersMapSearch = (props: any) => {

  const data = useStaticQuery(graphql`
    query {
      partners: allDrupalAffiliatedAgents {
        nodes {
          agentBrokerageOffice
          agentDashID
          agentFirstName
          agentLastName
          bio
          latitude
          longitude
          photo {              
            url
          }
          locationSmall
          locationName
          extraLocations {
            latitude
            locationName
            longitude
          }
          path
        }
      }      
    }
  `)

  const siteContext = useSiteContext()

  let agents: IMapAgent[] = data.partners.nodes.map((node: any): IMapAgent => {
    const { agentFirstName, agentLastName, latitude, longitude, locationName, photo } = node

    const locations: { lat: number; lng: number; name?: string; nameSmall?: string }[] = []
    const parsedLat = Number(latitude) || null
    const parsedLng = Number(longitude) || null
    if (parsedLat && parsedLng) {
      locations.push({ lat: parsedLat, lng: parsedLng, name: locationName })
    }
    node.extraLocations?.forEach((location: any) => {
      const { latitude, longitude, locationName } = location
      const lat = Number(latitude) || null
      const lng = Number(longitude) || null
      if (lat && lng) {
        locations.push({ lat: lat, lng: lng, name: locationName })
      }
    })

    return {
      firstName: agentFirstName,
      lastName: agentLastName,
      headshot: photo,
      path: node?.path && {
        text: `Learn About ${agentFirstName}`,
        href: node.path
      },
      locations: locations
    }
  })

  agents = agents.filter(agent => agent.locations?.[0])

  return (
    <MapsSearch
      className={`partners-map-search`}
      searchBoxClassName={`${props.inverted ? "inverted" : ""}`}
      agents={agents}
      searchBoxLayout={props.searchBoxLayout}
      searchBoxTitle={props.searchBoxTitle}
      markerInfoWindowTitle={props.markerInfoWindowTitle}
      mapTheme={props.mapTheme}
      linkFunc={props => {
        return (
          <Link
            to={props.href ?? ""}
            className={`${props.className}`}
            key={props.key}
            title={props.title}
          >
            {props.children}
          </Link>
        )
      }}
      satelliteMode={props.satelliteMode}
      {...siteContext.globalPartnerMapSearchProps}
    />
  )
}

export default PartnersMapSearch 

export const query = graphql`
fragment DrupalPartnersMapSearchContent on DrupalPartnersMapSearch {
    id
    inverted
    mapTheme
    markerInfoWindowTitle
    searchBoxLayout
    searchBoxTitle
    satelliteMode
}
`